import Backdrop from '@material-ui/core/Backdrop';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import { useSnackbar } from 'notistack';
import React, { useCallback, useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import SelectRackType from '../../components/Form/SelectRackType';
import LoadingUI from '../../components/ui/LoadingUI';
import { useAuth } from '../../hooks/auth';
import { PackingFCM, PackingFCMPost } from '../../interfaces/PackingFcm';
import MvmApi from '../../services/MvmApi';
import { useStyles } from './Style';



type Props = {
  causalCode: string,
  clickHandlerCalbkack?: () => void,
  clickHandlerClose?: () => void,
  handleSetSuccess?: (value: boolean) => void
}

const PackingFCMForm: React.FC<Props> = (props) => {
  const classes = useStyles();
  const [packingFcm, setpackingFcm] = useState<PackingFCM | any>();
  const [loading, setLoading] = useState(true);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const { t } = useTranslation("PackingFcm");
  const { t: tval } = useTranslation("Validation");
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useAuth();
  const { reset, control, getValues, setError, clearErrors, setValue } = useForm<any>(
    {
      defaultValues: {}
    });



  const handleSubmit2 = useCallback(
    async (/*data: PackingFCMPost*/) => {

      // if(submitData == null || submitData == undefined)
      // return;
      var formData = getValues();

      if (!(await yupValidationAddNewItemOnList(formData))) {
        return;
      }


      var objectString = JSON.stringify(formData!);
      var object = null;

      if (objectString !== null && objectString !== undefined)
        object = JSON.parse(objectString);

      const obj: PackingFCMPost = {
        Id: 0,
        CompanyId: +user.company.companyID,
        RackTypeCode: object?.RackTypeCode.rackTypeCode,
        PackingDescriptionCode: object?.RackTypeCode.rackTypeDescription,
        UpdatedBy: user.userName,
        CreatedBy: user.userName
      };

      setOpenBackdrop(true);
      if (props.causalCode != null && props.causalCode !== "") {
        obj.Id = +props.causalCode;

        MvmApi.putPackingFCM(obj)
          .then(result => {
            enqueueSnackbar(t("returnSubmitEditFormSuccess"), { variant: 'success' });
            if (props && props.clickHandlerCalbkack)
              props.clickHandlerCalbkack()
          }).finally(() => {
            setOpenBackdrop(false);
          });
      }
      else {

        MvmApi.postPackingFCM(obj)
          .then(result => {
            enqueueSnackbar(t("returnSubmitFormSuccess"), { variant: 'success' });
            if (props && props.handleSetSuccess)
              props.handleSetSuccess(true);

            if (props && props.clickHandlerCalbkack)
              props.clickHandlerCalbkack()
          }).finally(() => {
            setOpenBackdrop(false);
          });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props, enqueueSnackbar, t]
  );

  const getCausal = useCallback(
    (causalCode: string) => {
      if (props.causalCode && props.causalCode !== "") {
        setLoading(true);
        MvmApi.getPackingFCM(causalCode).then(async (result) => {
          if (result) {
            reset({
              RackTypeCode: {
                label: result.rackTypeCode + " - " + result.packingDescriptionCode,
                value: result.rackTypeCode
              }
            });
            setpackingFcm(result);

          }
        }).finally(() => {
          setLoading(false);
        });
      }
      else {
        let c: PackingFCMPost = {
          Id: 0,
          CompanyId: 0,
          RackTypeCode: "",
          PackingDescriptionCode: "",
          CreatedBy: "",
          UpdatedBy: "",
        };

        setpackingFcm(c)
      }
    },
    [props]
  );

  useEffect(() => {
    setLoading(false);
    getCausal(props.causalCode);
    // OptionValueApi.searchStatus('TipoUsuerCausal').then(response => {
    //     if (response) {
    //         setOptionsResponsibleUser(response.map(
    //             (status: any) => ({
    //                 value: status.code, text: status.description
    //             })));
    //     }
    // });
  }, [props, getCausal]);

  // useEffect(() => {


  //     if(submitData == null || submitData == undefined)
  //         return;


  //     if (!(yupValidationAddNewItemOnList(submitData)))
  //     { 
  //         return
  //     }


  //     var objectString = JSON.stringify(submitData!);
  //     var object = null;

  //     if(objectString != null && objectString != undefined)
  //         object =  JSON.parse(objectString);

  //         const obj: PackingFCMPost = {
  //             Id: 0,
  //             CompanyId: +user.company.companyID,
  //             PackingTypeCode: object?.PackingTypeCode.value,                  
  //             ProviderCode: object?.ProviderCode.code,
  //             PackingDescriptionCode: "",
  //             UpdatedBy: user.userName
  //         };

  //     //handleSubmit2(obj);

  // }, [submitData]);

  const yupValidationAddNewItemOnList = async (data: any) => {

    clearErrors(["RackTypeCode"])
    try {
      const schema = Yup.object().shape({
        RackTypeCode: Yup.object().nullable()
          .required(tval("requiredField")),
      })
      await schema.validate(data, {
        abortEarly: false,
      })

    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          setError(error.path?.split('.')[0] as "RackTypeCode", { message: error.message })
        })
      }

      return false
    }

    return true
  }

  return (

    loading ?
      <LoadingUI />
      :
      <React.Fragment>

        <Backdrop className={classes.backdrop} open={openBackdrop}>
          <CircularProgress color="inherit" />
        </Backdrop>


        <form translate={undefined} >
          <Grid container spacing={2} id="formConcierge">

            <Grid item xs={12}>
              <Grid item xs={12} style={{ marginRight: 8, marginLeft: -8 }}>
                <SelectRackType
                  label={t("fcmCode")}
                  name="RackTypeCode"
                  control={control}
                  style={{ width: '100%' }}
                  multiple={false} />
              </Grid>
            </Grid>

          </Grid>

          <Grid container spacing={2}>

            <Grid item xs={12} className={classes.footForm}>
              <Button variant="contained" className={classes.rootCancelButton} onClick={() => props && props.clickHandlerClose ? props.clickHandlerClose() : null}>
                {t("cancel")}
              </Button>

              <Button variant="contained" color="primary"
                className={classes.rootButton}
                onClick={handleSubmit2/*handleSubmit(data => {setSubmitData(data);})*/}>
                {t("confirm")}
              </Button>
            </Grid>

          </Grid>

        </form>
      </React.Fragment>

  )
}
export default PackingFCMForm;
